






























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    components: {
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class Popup extends Vue {
    // Member
    public visibility = false;
        
    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: false, default: 'Window'})
    public type?: 'Window' | 'Card';

    @Prop({ required: false })
    public title?: string;

    @Prop({ required: false })
    public icon?: string;

    @Prop({ required: false })
    public maxWidth?: number | string;

    @Prop({ required: false })
    public minHeight?: number | string;

    @Prop({ required: false, default: false, type: Boolean })
    public persistent!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public fullscreen!: boolean;

    @Prop({ required: false })
    public color?: string;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }
    
    // Watcher:
    @Watch('visible')
    public onModelChanged(value: boolean): void {
        if(value) {
            this.$emit('opened');
        } else {
            this.$emit('closed');
        }
    }

    // Lifecycle Methods:

    // Methods:
    public close(): void {
        this.visible = false;
    }
}
